import { useCallback, useEffect, useState } from 'react';
import { ManagedAccountsApi } from '@/api/clients/managed-accounts/managed-accounts.api';

export const useGetManagedAccount = (id) => {
  const [managedAccount, setManagedAccount] = useState(null);
  const [loading, setLoading] = useState(Boolean(id));
  const [error, setError] = useState(null);

  const fetchManagedAccount = useCallback(() => {
    setError(null);

    if (!id) {
      setManagedAccount(null);
      setLoading(false);
      return Promise.resolve();
    }

    setLoading(true);

    return ManagedAccountsApi.get(id)
      .then((response) => {
        setManagedAccount(response.data.data);
      })
      .catch((requestError) => {
        setError(
          requestError.response?.data?.message ||
            'Failed to load the managed account',
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    fetchManagedAccount();
  }, [fetchManagedAccount]);

  return { managedAccount, loading, error, refetch: fetchManagedAccount };
};
